<template>
  <div class="l-wrap">
    <Header />
    <router-view />
    <Footer />
  </div>
</template>

<script>
import Footer from '@/components/layouts/Footer';
import Header from '@/components/layouts/Header';

export default {
  components: {
    Footer,
    Header
  },

  data() {
    return {};
  },

  computed: {
    hasFooter() {
      return this.$route.matched.some(record => record.meta.hasFooter);
    },
    hasHeader() {
      return this.$route.matched.some(record => record.meta.hasHeader);
    }
  },
  methods: {}
};
</script>

<style lang="scss"></style>
